export const exportIcsFile = ({expirationDate, yearMakeModel, offerId}) => {
  const formatDate = (date: Date): string => {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}${month}${day}`;
  };

  const parseDate = (dateString: string): Date => {
    // Handle both M/D/YYYY, MM/DD/YYYY, D/M/YYYY, and DD/MM/YYYY formats
    const dateParts = dateString.split('/').map(val => parseInt(val, 10));
    let [first, second, year] = dateParts;
    
    let monthValue: number;
    let dayValue: number;
    
    // Auto-detect date format based on values
    if (first > 12) {
      // First part > 12 means DD/MM/YYYY format
      dayValue = first;
      monthValue = second;
    } else if (second > 12) {
      // Second part > 12 means MM/DD/YYYY format
      monthValue = first;
      dayValue = second;
    } else {
      // Ambiguous case: default to US format (MM/DD/YYYY)
      monthValue = first;
      dayValue = second;
    }
    
    return new Date(Date.UTC(year, monthValue - 1, dayValue));
  };


  const addDays = (date: Date, days: number): Date => {
    const result = new Date(date);
    result.setUTCDate(result.getUTCDate() + days);
    return result;
  };

  const expirationDateObj = parseDate(expirationDate);
  const nextDay = addDays(expirationDateObj, 1);

  // Create ICS file content
  const fileContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Kelley Blue Book//ICO Offer Expiration//EN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:kbb-ico-${offerId}-${Date.now()}@kbb.com`,
    `DTSTART;VALUE=DATE:${formatDate(expirationDateObj)}`,
    `DTEND;VALUE=DATE:${formatDate(nextDay)}`,
    'SUMMARY:Kelley Blue Book Instant Cash Offer Expiration',
    `DESCRIPTION:The offer on your ${yearMakeModel || 'vehicle'} will expire on ${expirationDate}`,
    'STATUS:CONFIRMED',
    'TRANSP:TRANSPARENT',
    // Remind the user 15 hours before expiration
    'BEGIN:VALARM',
    'TRIGGER;VALUE=DURATION:-PT15H',
    'ACTION:DISPLAY',
    'DESCRIPTION:Reminder: Your Kelley Blue Book Instant Cash Offer expires tomorrow',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\r\n');
  
  downloadIcsFile(fileContent);
}

// Download file
export const downloadIcsFile = (fileContent): void => { 
  const blob = new Blob([fileContent], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob); 
  const link = document.createElement('a');
  link.href = url;
  link.download = 'kbb-instant-cash-offer-expiration.ics';
  link.setAttribute('target', '_blank');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
